import { RedirectToMissionsPage } from '@sorare/gameplay/src/components/missions/RedirectToMissionsPage';

const MLBMissionsPage = () => {
  return <RedirectToMissionsPage />;
};

export default MLBMissionsPage;
